import React from 'react';
import styles from '../css/comuns/Depoimentos.module.css';
import { config } from '../../data';

const Depoimentos = () => {
  const primeiroDepoimento = config.content.depoimentos[0];
  
  return (
    <section className={`${styles['secao']} py-5 ${styles['fundo-claro']}`}>
      <div className="container">
        <h2 className={`text-center ${styles['texto-oni-azul']} mb-5`}>{config.texts.depoimentos.titulo}</h2>
        <div className="row">
          <div className="col-md-8 mx-auto">
            <div className={styles['depoimento']}>
              <p className={styles['destaque']}>"{primeiroDepoimento.text}"</p>
              <p className={styles['autor']}>- {primeiroDepoimento.name}, {primeiroDepoimento.location}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Depoimentos;